module.exports = __webpack_public_path__ + "7c1fd5f6b54ce41bdc75481ffbf9557d.svg";